import { UserActions } from '@next/core-lib/user';
import { createReducer, on } from '@ngrx/store';

import { FertilityState } from '../../models/fertility.model';
import * as FertilityActions from '../actions/fertility-actions';

export const initialState: FertilityState = {
  cows: null,
  fertilitySummary: null,
};

export const fertilityReducer = createReducer<FertilityState>(
  initialState,
  on(FertilityActions.loadCowsByDateSuccess, (state, { cows }) => ({
    ...state,
    cows,
  })),
  on(FertilityActions.loadFertilitySummarySucces, (state, { fertilitySummary }) => ({
    ...state,
    fertilitySummary,
  })),
  on(UserActions.relationshipSelected, () => initialState),
);
